var render = function render(){var _vm=this,_c=_vm._self._c;return _c('diffInput',{attrs:{"optList":_vm.filterType,"type":"select","title":"Bölge"},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})
}
var staticRenderFns = []

export { render, staticRenderFns }